import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import CustomSelect from "../../../../helpers/ui/CustomSelect";
import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";

class IndexView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      provinceOptions: [],
      selectedEmployee: null,
      reformatOptions: true,
      polaKerjaOptions: [],
      selectedPolaKerja: null,
      isLoadingOptPolaKerja: true,
      mandatoryOptions: [
        {
          label: "Ya",
          value: 1,
        },
        {
          label: "Tidak",
          value: 0,
        },
      ],
      statusOptions: [
        {
          label: "Aktif",
          value: 1,
        },
        {
          label: "Tidak Aktif",
          value: 0,
        },
      ],
      listStopOptions: [],
      selectedType: null,
    };
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      //   newObj["label"] = data['employee_nip'] +' - '+ data[label];
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  handleSelectChange = (selectedOption) => {
    const selectedValues = selectedOption.map((option) => option.value);
    this.setState({ selectedType: selectedValues });
  };

  submitData = async () => {
    const files = ["file-template"];
    const formData = generateFormData(this.state.dataForm, files);
    await this.createBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          // console.log();
          if (result.data.status === true) {
            console.log("buat");
            this.setState({
              loading: false,
              success: true,
            });
          } else {
            console.log("ada");
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.listStopChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              listStopOptions: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchTypeStop();
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.listStopChannel?.unsubscribe();
    // this.createBloc.createChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Tambah Dokumen</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_name"
                        className="col-md-2 col-form-label"
                      >
                        Nama Dokumen <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder="Nama Dokumen"
                          name="retired_doctype_name"
                          id="retired_doctype_name"
                          validate={{ required: { value: true } }}
                          type="text"
                          className="form-control"
                          errorMessage="Masukkan Nama Dokumen"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_tooltip"
                        className="col-md-2 col-form-label"
                      >
                        Tooltip <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <AvField
                          placeholder="Tooltip"
                          name="retired_doctype_tooltip"
                          id="retired_doctype_tooltip"
                          validate={{ required: { value: true } }}
                          type="textarea"
                          className="form-control"
                          errorMessage="Masukkan Tooltip"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_type_uuid"
                        className="col-md-2 col-form-label"
                      >
                        Jenis <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <CustomSelect
                          isMulti
                          name={`retired_doctype_type_uuid`}
                          options={this.state.listStopOptions}
                          onChange={this.handleSelectChange} // Handle selection change
                          placeholder="Pilih Jenis Pemberhentian"
                        />
                        <AvField
                          type="hidden"
                          name="retired_doctype_type_uuid"
                          value={this.state.selectedType}
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih Jenis Pemberhentian"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_is_required"
                        className="col-md-2 col-form-label"
                      >
                        Mandatory <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name={`retired_doctype_is_required`}
                          errorMessage="Pilih Mandatory"
                          options={this.state.mandatoryOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Mandatory"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_sort"
                        className="col-md-2 col-form-label"
                      >
                        Nomor Urut <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder="Nomor Urut"
                          name="retired_doctype_sort"
                          id="retired_doctype_sort"
                          validate={{ required: { value: true } }}
                          type="number"
                          className="form-control"
                          errorMessage="Masukkan Nomor Urut"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_status"
                        className="col-md-2 col-form-label"
                      >
                        Status <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name={`retired_doctype_status`}
                          errorMessage="Pilih Status"
                          options={this.state.statusOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        File Template
                      </Label>
                      <Col md="6">
                        <FileInput name="file-template" col="2" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo={this.state.failedInfo} //"Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/dokumen_pensiun.html?" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
